<template>
  <div>
    <SellHeader :img_header="header_image" header="แก้ไขล็อต-การส่งของ" :link_back="link_back"/>
    <Order_partner_edit_lots/>
  </div>
</template>

<script>
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/boxes_sell.png";
import Order_partner_edit_lots from "@/components/admin/sell/Order_partner_edit_lots";
export default {
  name: "OrderPartnerEditLots",
  components: {
    Order_partner_edit_lots,
    SellHeader
  },
  data() {
    return {
      header_image: HeaderImage,
      link_back: 'sell/orderpartnerdetail/' + this.$route.params.id
    }
  }
}
</script>

<style scoped>

</style>
